import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["actualDeparture", "actualArrival"];

  initialize() {
    this.currentDateInPolTz = this.element.dataset.currentDateInPolTz;
    this.currentDateInPodTz = this.element.dataset.currentDateInPodTz;
  }

  connect() {
    $("#shipment_actual_departure").on("select2:select", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });
  }

  triggerSelect2() {
    $(`#${this.element.id} select:not(.default-select, .search-select-input)`).select2();
  }

  warnIfActualDateInFuture(port_type) {
    let currentDate;
    let newDate;
    switch (port_type) {
      case "pol":
        currentDate = new Date(this.currentDateInPolTz);
        newDate = new Date(this.actualDepartureTarget.value);
        break;

      case "pod":
        currentDate = new Date(this.currentDateInPodTz);
        newDate = new Date(this.actualArrivalTarget.value);
        break;
    }

    const shipmentUpdateButton = document.getElementById("shipment-update-button");
    if (newDate > currentDate) {
      shipmentUpdateButton.setAttribute(
        "data-confirm",
        "An actual departure or arrival is in the future, are you sure?"
      );
    } else {
      shipmentUpdateButton.removeAttribute("data-confirm");
    }
  }

  changedPol() {
    this.warnIfActualDateInFuture("pol");
  }

  changedPod() {
    this.warnIfActualDateInFuture("pod");
  }
}
